import PrivateRoute from 'auth/PrivateRoute';
import { Route, Routes } from 'react-router-dom';
import Clients from './Clients';
import Client from './Clients/Client';
import NewContract from './Clients/Client/Contracts/NewContract';
import DocumentRenewal from './Clients/Client/documents/DocumentRenewal';
import DocumentSettings from './Clients/Client/documents/DocumentSettings';
import NewDocument from './Clients/Client/documents/NewDocument';
import EditClient from './Clients/EditClient';
import NewClient from './Clients/NewClient';
import Contract from './guest/Contract';
import ContractConfirmation from './guest/Contract/ContractConfirmation';
import Document from './guest/Contract/Document';
import LeaseApplication from './guest/LeaseApplication';
import LeaseApplicationConfirmation from './guest/LeaseApplication/LeaseApplicationConfirmation';
import Renewal from './guest/Renewal';
import RenewalConfirmation from './guest/Renewal/RenewalConfirmation';
import Home from './Home';
import Locations from './Locations';
import EditLocation from './Locations/EditLocation';
import Location from './Locations/Location';
import NewLocation from './Locations/NewLocation';
import Suite from './Suites/Suite';

function App() {
  return (
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Home />} />
        <Route path="clients" element={<Clients />}>
          <Route path="new" element={<NewClient />} />
          <Route path=":clientId" element={<Client />}>
            <Route path="edit" element={<EditClient />} />
            <Route path="contracts/new" element={<NewContract />} />
            <Route path="documents">
              <Route path="new" element={<NewDocument />} />
              <Route path=":documentId">
                <Route path="settings" element={<DocumentSettings />} />
                <Route path="renew" element={<DocumentRenewal />} />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="locations" element={<Locations />}>
          <Route path="new" element={<NewLocation />} />
          <Route path=":locationId" element={<Location />}>
            <Route path="edit" element={<EditLocation />} />
          </Route>
          <Route path=":locationId/suite/:suiteNumber" element={<Suite />} />
        </Route>
      </Route>
      <Route path="guest">
        <Route path="lease-application" element={<LeaseApplication />} />
        <Route path="lease-application/confirmation" element={<LeaseApplicationConfirmation />} />
        <Route path="contract" element={<Contract />}>
          <Route path="documents/:documentId" element={<Document />} />
        </Route>
        <Route path="contract/confirmation" element={<ContractConfirmation />} />
        <Route path="renewal" element={<Renewal />} />
        <Route path="renewal/confirmation" element={<RenewalConfirmation />} />
      </Route>
    </Routes>
  );
}

export default App;
